import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { articles } from '@/mocks/articlesData';

const articleHeroImages: Record<string, string> = {
  'article-001': 'https://readdy.ai/api/search-image?query=Anime%20style%20new%20season%20preview%20illustration%2C%20movie%20poster%20collage%20style%2C%20vibrant%20colors%2C%20Japanese%20anime%20aesthetic%2C%20summer%20vibes%2C%20cinematic%20composition&width=1800&height=700&seq=article-hero-001&orientation=landscape',
  'article-002': 'https://readdy.ai/api/search-image?query=Frieren%20anime%20style%20fantasy%20landscape%2C%20elf%20character%20in%20beautiful%20meadow%2C%20soft%20golden%20sunlight%2C%20healing%20atmosphere%2C%20cinematic%20composition&width=1800&height=700&seq=article-hero-002&orientation=landscape',
  'article-003': 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20illustration%2C%20modern%20urban%20setting%2C%20beautiful%20character%20designs%2C%20ink%20wash%20painting%20influence%2C%20artistic%20composition&width=1800&height=700&seq=article-hero-003&orientation=landscape',
  'article-004': 'https://readdy.ai/api/search-image?query=Kimetsu%20no%20Yaiba%20infinity%20castle%20scene%2C%20dramatic%20demon%20slayer%20battle%2C%20flame%20and%20water%20effects%2C%20dark%20atmospheric%20background%2C%20epic%20anime%20art&width=1800&height=700&seq=article-hero-004&orientation=landscape',
  'article-005': 'https://readdy.ai/api/search-image?query=Peaceful%20anime%20style%20nature%20scene%2C%20cozy%20camping%20setting%2C%20soft%20pastel%20colors%2C%20healing%20atmosphere%2C%20warm%20sunlight%2C%20cinematic%20composition&width=1800&height=700&seq=article-hero-005&orientation=landscape',
  'article-006': 'https://readdy.ai/api/search-image?query=Isekai%20anime%20style%20fantasy%20world%2C%20magical%20portal%20opening%2C%20dramatic%20sky%2C%20adventure%20atmosphere%2C%20cinematic%20composition%2C%20high%20quality&width=1800&height=700&seq=article-hero-006&orientation=landscape',
};

const relatedArticleImages: Record<string, string> = {
  'article-001': 'https://readdy.ai/api/search-image?query=Anime%20season%20preview%20thumbnail%2C%20minimalist%20style%2C%20soft%20colors%2C%20clean%20composition&width=120&height=120&seq=related-thumb-001&orientation=squarish',
  'article-002': 'https://readdy.ai/api/search-image?query=Frieren%20anime%20thumbnail%2C%20fantasy%20theme%2C%20minimalist%20style%2C%20soft%20colors&width=120&height=120&seq=related-thumb-002&orientation=squarish',
  'article-003': 'https://readdy.ai/api/search-image?query=Chinese%20anime%20thumbnail%2C%20modern%20style%2C%20minimalist%2C%20clean%20composition&width=120&height=120&seq=related-thumb-003&orientation=squarish',
  'article-004': 'https://readdy.ai/api/search-image?query=Kimetsu%20anime%20thumbnail%2C%20action%20theme%2C%20minimalist%20style%2C%20dramatic%20colors&width=120&height=120&seq=related-thumb-004&orientation=squarish',
  'article-005': 'https://readdy.ai/api/search-image?query=Healing%20anime%20thumbnail%2C%20nature%20theme%2C%20minimalist%20style%2C%20soft%20pastel%20colors&width=120&height=120&seq=related-thumb-005&orientation=squarish',
  'article-006': 'https://readdy.ai/api/search-image?query=Isekai%20anime%20thumbnail%2C%20fantasy%20theme%2C%20minimalist%20style%2C%20adventure%20vibes&width=120&height=120&seq=related-thumb-006&orientation=squarish',
};

const comments = [
  {
    id: 'comment-1',
    author: '深夜追番人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%2C%20soft%20blue%20and%20white%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    date: '2小时前',
    content: '写得太好了！对新番的分析很到位，特别是关于芙莉莲的部分，完全说出了我想说的话。',
    likes: 128,
  },
  {
    id: 'comment-2',
    author: '二次元即正义',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20pink%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    date: '5小时前',
    content: '等鬼灭无限城等太久了！感谢小编的详细整理，已经mark好上映时间了。',
    likes: 96,
  },
  {
    id: 'comment-3',
    author: '国漫崛起',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20young%20adult%20avatar%20portrait%2C%20soft%20warm%20colors%2C%20simple%20clean%20background%2C%20chibi%20art%20style&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    date: '8小时前',
    content: '国漫部分写得很客观，现在的国产动画确实越来越好了，希望樱花动漫能多推国漫。',
    likes: 74,
  },
];

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = id || 'article-001';
  const article = articles.find((a) => a.id === articleId) || articles[0];
  const heroImageUrl = articleHeroImages[articleId] || articleHeroImages['article-001'];

  const relatedArticles = articles
    .filter((a) => a.id !== article.id)
    .slice(0, 3);

  return (
    <>
      <SEOHead
        title={`${article.title} - 樱花动漫文章 - 樱花动漫网`}
        description={article.excerpt}
        keywords={`${article.tags.join(',')},樱花动漫,动漫文章,动漫资讯`}
        canonicalUrl={`http://knsink.cn/article/${article.id}`}
        ogType="article"
        ogImage={articleHeroImages[articleId] || articleHeroImages['article-001']}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            author: {
              '@type': 'Person',
              name: article.author,
            },
            datePublished: article.publishDate,
            dateModified: article.publishDate,
            publisher: {
              '@type': 'Organization',
              name: '樱花动漫',
              url: 'http://knsink.cn/',
            },
            url: `http://knsink.cn/article/${article.id}`,
            image: articleHeroImages[articleId] || articleHeroImages['article-001'],
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `http://knsink.cn/article/${article.id}`,
            },
            wordCount: article.content.length,
            inLanguage: 'zh-CN',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'http://knsink.cn/' },
              { '@type': 'ListItem', position: 2, name: '动漫文章', item: 'http://knsink.cn/article/article-001' },
              { '@type': 'ListItem', position: 3, name: article.category, item: `http://knsink.cn/article/${article.id}` },
              { '@type': 'ListItem', position: 4, name: article.title },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: `这篇文章主要讲了什么内容？`,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: article.excerpt,
                },
              },
              {
                '@type': 'Question',
                name: `这篇文章适合什么样的读者？`,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `本文适合对${article.category}感兴趣的动漫爱好者阅读，特别是${article.tags.slice(0, 2).join('、')}等话题的关注者。`,
                },
              },
            ],
          },
        ]}
      />
      <Navbar />
      <main>
        <section className="relative w-full min-h-[350px] md:min-h-[450px] flex items-center overflow-hidden">
          <img
            src={heroImageUrl}
            alt={article.title}
            className="absolute inset-0 w-full h-full object-cover object-top z-0"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45 z-[1]"></div>
          <div className="relative z-[2] w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-24">
            <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
              <div className="w-full lg:w-3/5">
                <h1 className="text-xl md:text-3xl lg:text-4xl font-bold font-heading text-background-50 leading-tight">
                  {article.title}
                </h1>
              </div>
              <div className="w-full lg:w-2/5 flex flex-col items-start lg:items-end lg:justify-end lg:pt-12">
                <p className="text-sm text-background-200/80 max-w-xs leading-relaxed mb-3 lg:text-right">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-background-300">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.readCount.toLocaleString()} 阅读</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Breadcrumb
          items={[
            { label: '动漫文章', href: `/article/${article.id}` },
            { label: article.category, href: `/article/${article.id}` },
            { label: article.title },
          ]}
        />

        <article className="w-full bg-background-50 py-10 md:py-14">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-12">
              <div className="w-full lg:w-2/3">
                <div className="flex items-center gap-3 mb-6 flex-wrap">
                  <span className="inline-block px-3 py-1 rounded-full border border-primary-300 text-primary-600 text-xs font-medium">
                    {article.category}
                  </span>
                  <div className="flex items-center gap-1.5 flex-wrap">
                    {article.tags.map((tag) => (
                      <span key={tag} className="text-xs text-foreground-500">
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="text-foreground-700 leading-relaxed">
                  {article.content.split('\n\n').map((paragraph, idx) => {
                    if (paragraph.startsWith('## ')) {
                      return (
                        <h2 key={idx} className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mt-8 mb-4">
                          {paragraph.replace('## ', '')}
                        </h2>
                      );
                    }
                    return (
                      <p key={idx} className="mb-4 text-sm md:text-base leading-relaxed">
                        {paragraph}
                      </p>
                    );
                  })}
                </div>

                <div className="flex items-center justify-between mt-10 pt-6 border-t border-background-200">
                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1.5 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-thumb-up-line"></i>
                      <span>赞 {article.readCount}</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-chat-1-line"></i>
                      <span>评论 {article.commentCount}</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
                      <i className="ri-bookmark-line text-sm text-foreground-600"></i>
                    </button>
                  </div>
                </div>

                <div className="mt-10">
                  <h3 className="text-lg font-bold font-heading text-foreground-900 mb-5">
                    评论 <span className="text-sm font-normal text-foreground-500">({article.commentCount})</span>
                  </h3>
                  <div className="flex flex-col gap-4">
                    {comments.map((comment) => (
                      <div key={comment.id} className="flex gap-3 p-4 rounded-lg bg-background-100">
                        <img
                          src={comment.avatarUrl}
                          alt={comment.author}
                          className="w-9 h-9 rounded-full object-cover flex-shrink-0"
                          loading="lazy"
                        />
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-sm font-semibold text-foreground-900">{comment.author}</span>
                            <span className="text-xs text-foreground-400">{comment.date}</span>
                          </div>
                          <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                          <div className="flex items-center gap-3 mt-2">
                            <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                              <i className="ri-thumb-up-line"></i>
                              <span>{comment.likes}</span>
                            </button>
                            <button className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                              回复
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <aside className="w-full lg:w-1/3">
                <div className="sticky top-20">
                  <div className="bg-background-100 rounded-lg p-5 mb-5">
                    <h4 className="text-sm font-bold font-heading text-foreground-900 mb-4">关于作者</h4>
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center">
                        <i className="ri-user-3-line text-primary-600"></i>
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-900">{article.author}</p>
                        <p className="text-xs text-foreground-500">樱花动漫编辑</p>
                      </div>
                    </div>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      资深动漫爱好者，专注动漫资讯与深度分析，为你带来最新最热的动漫内容。
                    </p>
                  </div>

                  <div className="bg-background-100 rounded-lg p-5 mb-5">
                    <h4 className="text-sm font-bold font-heading text-foreground-900 mb-4">相关文章</h4>
                    <div className="flex flex-col gap-4">
                      {relatedArticles.map((ra) => (
                        <Link
                          key={ra.id}
                          to={`/article/${ra.id}`}
                          className="group flex gap-3 cursor-pointer"
                        >
                          <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0 bg-background-200">
                            <img
                              src={relatedArticleImages[ra.id] || relatedArticleImages['article-001']}
                              alt={ra.title}
                              className="w-full h-full object-cover"
                              loading="lazy"
                            />
                          </div>
                          <div className="flex-1 min-w-0">
                            <h5 className="text-xs font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
                              {ra.title}
                            </h5>
                            <p className="text-xs text-foreground-400 mt-1">{ra.publishDate}</p>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="bg-foreground-950 rounded-lg p-5">
                    <h4 className="text-sm font-bold font-heading text-background-50 mb-2">订阅樱花动漫</h4>
                    <p className="text-xs text-background-400 leading-relaxed mb-4">
                      获取最新动漫资讯和番剧更新，不错过任何精彩内容
                    </p>
                    <button className="w-full py-2.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                      立即订阅
                    </button>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}